module.exports = __webpack_public_path__ + "media/images/emblems/Vufflens-le-Chateau-coat_of_arms-82ef9ea299b210c708f71b24c0ba3961.svg";